import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Camera, ClockCounterClockwise, User, Leaf } from "@phosphor-icons/react";
import Onboarding from "@/components/Onboarding";

const tabs = [
  { to: "/snap",     label: "Snap",  Icon: Camera, testid: "tab-snap" },
  { to: "/history",  label: "Scans", Icon: ClockCounterClockwise, testid: "tab-history" },
  { to: "/profile",  label: "You",   Icon: User, testid: "tab-profile" },
];

export default function MobileShell({ children }) {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-[#F9F8F6] flex justify-center">
      <div className="w-full max-w-md min-h-screen flex flex-col relative" data-testid="app-shell">
        <header className="sticky top-0 z-30 nav-blur">
          <div className="flex items-center justify-between px-5 py-4">
            <Link to="/snap" className="flex items-center gap-2" data-testid="brand-link">
              <span className="w-8 h-8 rounded-full bg-[#2B422F] flex items-center justify-center">
                <Leaf size={15} weight="fill" className="text-[#E6D4C4]" />
              </span>
              <span className="font-serif-display text-xl tracking-tight text-[#1A2421]">Tally</span>
            </Link>
          </div>
        </header>

        <main className="flex-1 pb-28">{children}</main>

        <nav
          className="fixed bottom-0 left-0 right-0 z-30 pointer-events-none"
          aria-label="Primary"
          data-testid="bottom-nav"
        >
          <div className="mx-auto max-w-md px-4 pb-4 pt-2 pointer-events-auto">
            <div className="rounded-full bg-[#1A2421]/95 backdrop-blur-md shadow-[0_18px_40px_rgba(26,36,33,0.25)] grid grid-cols-3">
              {tabs.map(({ to, label, Icon, testid }) => (
                <NavLink
                  key={to}
                  to={to}
                  data-testid={testid}
                  className={({ isActive }) =>
                    `flex flex-col items-center gap-0.5 py-3 text-xs transition-colors ${
                      isActive ? "text-white" : "text-white/55 hover:text-white/80"
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <Icon size={20} weight={isActive ? "fill" : "regular"} />
                      <span className="tracking-wide">{label}</span>
                    </>
                  )}
                </NavLink>
              ))}
            </div>
          </div>
        </nav>

        {user?.email && <span className="sr-only" data-testid="navbar-user-email">{user.email}</span>}
      </div>
      <Onboarding user={user} />
    </div>
  );
}
